/**
Check if you have clicked outside the element
- It will set the observable to false if you click outside the element
- Elements within the element counts as inside
Usage: <element data-bind='clickOutsideElementObserver:observable'>

*/
ko.bindingHandlers.clickOutsideElementObserver = {
    init: function (element, valueAccessor) {
        var value = valueAccessor();

        function getParents(elm) {
            var result = [];
            for (var p = elm && elm.parentElement; p; p = p.parentElement) {
                result.push(p);
            }
            return result;
        }

        element.clickOutsideElementObserverHandler = function (e) {
            if (e.target != element && getParents(e.target).filter(function (index, parent) { return parent == element; }).length == 0) {
                if (element.contains(e.target)) {
                    return;
                }
                value(false);
            }
        }
    },

    update: function (element, valueAccessor) {
        var value = valueAccessor();

        if (value()) {
            setTimeout(function () {
                var html = document.getElementsByTagName("HTML")[0];
                html.addEventListener("click", element.clickOutsideElementObserverHandler);
                html.addEventListener("touchstart", element.clickOutsideElementObserverHandler);
            }, 0);
        } else {
            setTimeout(function () {
                var html = document.getElementsByTagName("HTML")[0];
                html.removeEventListener("click", element.clickOutsideElementObserverHandler);
                html.removeEventListener("touchstart", element.clickOutsideElementObserverHandler);
            }, 0);
        }
    }
};